export default function cancel(func) {
  return function(event) {
    event.stopPropagation();
    event.preventDefault();
    func?.(event);
  };
}
